module.exports = __webpack_public_path__ + "index/img/captcha.40c413a8.png";